import { cn } from "../utils/cn";

type SelectProps = {
  label: string;
  options: string[];
  hideLabel?: boolean;
  ariaLabel?: string;
  state?: "default" | "hover" | "active" | "focus" | "disabled" | "error";
  value?: string;
  onChange?: (value: string) => void;
  onFocus?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
  readOnly?: boolean;
};

export function Select({
  label,
  options,
  hideLabel = false,
  ariaLabel,
  state = "default",
  value,
  onChange,
  onFocus,
  disabled,
  readOnly,
}: SelectProps) {
  const isDisabled = disabled || state === "disabled";
  const stateClasses =
    state === "hover"
      ? "bg-surface-muted"
      : state === "active"
        ? "bg-border/40"
        : state === "focus"
          ? "outline outline-2 outline-primary/40 outline-offset-2"
          : state === "error"
            ? "border-danger"
          : "";
  const labelClass = state === "error" ? "text-danger" : "text-muted";
  const labelText = ariaLabel ?? label;
  return (
    <label className={cn("grid gap-2 text-sm", labelClass)}>
      <span className={cn(hideLabel && "sr-only")}>{label}</span>
      <select
        className={cn(
          "h-10 rounded-md border border-border bg-surface px-3 text-text",
          stateClasses,
          isDisabled && "opacity-50 cursor-not-allowed",
          readOnly && "cursor-pointer"
        )}
        disabled={isDisabled}
        aria-label={hideLabel ? labelText : undefined}
        value={value}
        onChange={(event) => {
          if (!readOnly) {
            onChange?.(event.target.value);
          }
        }}
        onFocus={onFocus}
      >
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    </label>
  );
}
